import moment from 'moment';
import { openDSWindow } from '../../../helpers/Window';
import { CustomIcon } from 'datastake-daf/dist/components';

export const getLanguage = (lng = '') => {
  if (lng.includes('en')) {
    return 'en';
  }

  if (lng.includes('fr')) {
    return 'fr';
  }
}

export const redirect = ({ type, id, mod, mode, item }) => {
  const viewMode = type === 'document' ? 'viewdd' : 'view';

  let url = `/${mod}/${viewMode}/${type}/${id}`

  // TODO: check namespace
  if (item.typeOfEvent === 'incident') {
    url = `/${mod}/${viewMode}/incidents/${id}`;
  } else if(item.typeOfEvent === 'testimonials') {
    url = `/${mod}/${viewMode}/testimonials/${id}`;
  } else {
    url = `/${mod}/${viewMode}/corrective-actions/${id}`;
  }

  if (mode === 'proxy') {
    openDSWindow({
      url: `/proxy${url}`,
      name: 'Linking Window Proxy',
    })
    return
  }

  return `/app${url}`;
};

export const renderType = ({ item = {}, t = (s) => s, type }) => {
  if (item.empty) {
    return <div className="daf-default-cell" />;
  }

  // TODO: check namespace
  if (item.typeOfEvent === 'incident') {
    return t('Incident');
  }

  return t('Corrective Action');
};

export const getColumns = ({ t, redirect = () => '', mod, language, mode = 'app' }) => [
  {
    title: 'ID',
    dataIndex: 'datastakeId',
    key: 'datastakeId',
  },
  {
    title: t('Type'),
    dataIndex: 'type',
    key: 'type',
    render: (type, all) => renderType({ item: all, t, type }),
  },
  {
    title: t('Name'),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: t('LinkedSubjects::lastUpdate'),
    dataIndex: 'updateAt',
    key: 'updateAt',
    render: (updatedAt, all) => {
      if (all.empty) {
        return <div className="daf-default-cell" />;
      }

      return (
        <div className="daf-default-cell">
          {moment(updatedAt).format('DD MMM YYYY')}
        </div>
      );
    }
  },
  {
    title: '',
    dataIndex: 'actions',
    width: 50,
    key: 'actions',
    render: (_, all) => {
      if (all.empty) {
        return <div className="daf-default-cell" />;
      }

      return mode === 'proxy' ? (
        <a onClick={() => redirect({ id: all.datastakeId, type: all.type, mod, mode, item: all })} href="#">
          <CustomIcon name="LinkNewTab" width={14} height={14} color="#6C737F" />
        </a>
      ) : (
        <a href={redirect({ id: all.datastakeId, type: all.type, mod, mode, item: all })} target='_blank' rel="noreferrer">
          <CustomIcon name="LinkNewTab" width={14} height={14} color="#6C737F" />
        </a>
      );
    },
  },
];
